export default __webpack_public_path__ + "static/n1-77071f5f510353417f3f279dbf725839.jpg";